import React, { Component } from 'react';
import autobind from 'autobind-decorator';

import { goToSetupStep } from 'client/artist-ui/utils/next-setup-step';

export default class OnboardingSetupPanel extends Component {
	@autobind
	onAction () {
		const { step } = this.props;

		goToSetupStep(step);
	}

	render () {
		const { step, isPreview } = this.props;

		if (!step) {
			return null;
		}

		const isStripe = step.key === 'hasStripeSetup';
		const rootClass = [
			'acms-onboarding-panel',
			'acms-next-step',
			isStripe ? 'acms-next-step--stripe' : '',
			isPreview ? 'acms-onboarding-panel--preview' : ''
		].filter(Boolean).join(' ');

		return (
			<div className={ rootClass } data-ta="onboarding-setup-panel">
				<div className="acms-next-step__inner acms-onboarding-panel__inner">
					<p className="acms-onboarding-panel__kicker" aria-live="polite">
						<span className="acms-onboarding-panel__kicker-muted">Finish your setup:</span>{' '}
						<span className="acms-onboarding-panel__kicker-strong">{ step.panelTitleUpper }</span>
					</p>

					<button
						type="button"
						className="acms-onboarding-panel__text-action"
						onClick={ this.onAction }
					>
						{ step.actionLabel }
					</button>

					<p className="acms-onboarding-panel__desc">{ step.description }</p>

					{ step.stripeHint ? (
						<p className="acms-onboarding-panel__hint">{ step.stripeHint }</p>
					) : null }

					<button
						type="button"
						className="acms-onboarding-panel__text-action acms-onboarding-panel__text-action--secondary"
						onClick={ this.onAction }
					>
						Click here to get started
					</button>
				</div>
			</div>
		);
	}
}
